import React, {
    createContext,
    useContext,
    useEffect,
    useState,
    useCallback,
    useMemo
  } from 'react';
  import { getCartDataApi } from '../components/actioncreator';
  
  const CartContext = createContext();
  
  export const CartProvider = ({ children }) => {
    const [cartData, setCartData] = useState({ items: [] });
    const [hasFetched, setHasFetched] = useState(false);
  
    const cartDataApi = useCallback(() => {
      const token = localStorage.getItem('btoken');
      if (!token) {
        console.warn('No token found in localStorage');
        return;
      }
  
      getCartDataApi(token, (response) => {
        setCartData(response?.data || { items: [] });
      });
    }, []);
  
    useEffect(() => {
  
      if (!hasFetched) {
        cartDataApi();
        setHasFetched(true);
      }
    }, [hasFetched, cartDataApi]);
  
    const value = useMemo(() => ({ cartData, cartDataApi }), [cartData, cartDataApi]);
  
    return (
      <CartContext.Provider value={value}>
        {children}
      </CartContext.Provider>
    );
  };
  
  export const useCart = () => useContext(CartContext);
  